import { loadScript } from 'utils/helpers';

const STRIPE_CDN_URL = 'https://js.stripe.com/v3/';

export default async function loadStripe() {
  await loadScript(STRIPE_CDN_URL);
}
